var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16699 34.6667V25.1333L10.0753 6.5H36.8337V34.6667L21.667 49.8333L17.6587 45.825L20.4753 34.6667H2.16699ZM32.5003 10.8333H13.0003L6.50033 26V30.3333H26.0003L23.0753 42.25L32.5003 32.825V10.8333ZM36.8337 34.6667V30.3333H43.3337V10.8333H36.8337V6.5H47.667V34.6667H36.8337Z",
    fill: "#9B51E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/ThumbsDown.6151441d77c607dfbb270a68b1b6b958.svg";
export { ForwardRef as ReactComponent };